export default {
  vehicles: (state) => state.vehicles
}